import { Children, cloneElement } from "react";
import type { IDonutsComparisonWrapper } from "libs/design-system/src/types/charts/chart/donut_chart/donuts_comparison_wrapper";
import type { IChartInternalProps } from "libs/design-system/src/types/charts/chart/internal-props";
import { DonutChart } from "..";
import styles from "./donuts-comparison-wrapper.module.scss";

export const DonutsComparisonWrapper = ({ children, series, ...internalProps }: IDonutsComparisonWrapper) => {

  const { colors, labels } = (internalProps as IChartInternalProps);

  return (
    <div className={styles["donuts-comparison-wrapper"]}>
      {
        Children.map(children, (child: any, index: number) => {
          if (child?.type === DonutChart) {
            return cloneElement(child, {
              colors: colors,
              labels: labels,
              seriesFromParent: series,
              seriesIndex: index,
            })
          } else {
            return child;
          }
        })
      }
    </div>
  )
}